var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
// Making scripts work, per https://stackoverflow.com/a/47614491/392102
function activateScripts(el) {
    const scripts = Array.from(el.querySelectorAll('script'));
    const processOne = (() => {
        var _a;
        const s = scripts.shift();
        if (!s) {
            return;
        }
        const newScript = document.createElement('script');
        const p = (s.src) ? new Promise((resolve) => {
            newScript.onload = resolve;
        }) : Promise.resolve();
        Array.from(s.attributes)
            .forEach((a) => newScript.setAttribute(a.name, a.value));
        if (s.textContent) {
            newScript.appendChild(document.createTextNode(s.textContent));
        }
        newScript.async = false;
        (_a = s.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(newScript, s);
        p.then(processOne);
    });
    processOne();
}
export default function RawHTML(_a) {
    var { Tag = 'div', html, embed = false } = _a, otherProps = __rest(_a, ["Tag", "html", "embed"]);
    const ref = React.useRef();
    React.useEffect(() => {
        if (embed && ref.current) {
            activateScripts(ref.current);
        }
    });
    return (React.createElement(Tag, Object.assign({ ref, dangerouslySetInnerHTML: { __html: html } }, otherProps)));
}
